import { Store } from 'redux';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import {
  injectArticleBlockByIndexArray,
  InjectArticleBlockByIndexArrayParams,
} from '../../store/template/postPage/postPage.actions';
import { EventHandler } from './eventEmitters';
import {
  GET_PAGE_DATA,
  GET_PALETTE_DATA,
  INJECT_ACCESSIBILITY_ICON_TO_HEADER,
  INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from './events';
import {
  injectAccessibilityIcon,
  injectButtonToFooterLinksSection,
  injectButtonToMenu,
  injectVideoLogo,
  InjectVideoLogoParams,
} from '../../store/navigation/navigation.actions';
import { InjectButtonParams } from '../../store/navigation/navigation.utils';
import { getPageDataProtectedEventHandler } from './readEventHandlers/getPageData';
import { getPaletteDataProtectedEventHandler } from './readEventHandlers/getPaletteData';

export type ClientAPIWriteEventNames =
  typeof INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY
  | typeof INJECT_VIDEO_LOGO
  | typeof INJECT_BUTTON_TO_FOOTER_LINKS_SECTION
  | typeof INJECT_BUTTON_TO_MENU
  | typeof INJECT_ACCESSIBILITY_ICON_TO_HEADER;
export type ClientAPIReadEventNames = typeof GET_PAGE_DATA | typeof GET_PALETTE_DATA;

type HandlerCreator = (store: Store<AppState, AppActions>) => EventHandler;
type HandlerCreatorsForWriteEvents = { [key in ClientAPIWriteEventNames]: HandlerCreator }
type HandlerCreatorsForReadEvents = { [key in ClientAPIReadEventNames]: HandlerCreator }

export const handlerCreatorsForWriteEvents: HandlerCreatorsForWriteEvents = {
  [INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY]: (store: Store<AppState, AppActions>) => (params: InjectArticleBlockByIndexArrayParams) => store.dispatch(injectArticleBlockByIndexArray(params)),
  [INJECT_VIDEO_LOGO]: (store: Store<AppState, AppActions>) => (params: InjectVideoLogoParams) => store.dispatch(injectVideoLogo(params)),
  [INJECT_BUTTON_TO_FOOTER_LINKS_SECTION]: (store: Store<AppState, AppActions>) => (params: InjectButtonParams) => store.dispatch(injectButtonToFooterLinksSection(params)),
  [INJECT_BUTTON_TO_MENU]: (store: Store<AppState, AppActions>) => (params: InjectButtonParams) => store.dispatch(injectButtonToMenu(params)),
  [INJECT_ACCESSIBILITY_ICON_TO_HEADER]: (store: Store<AppState, AppActions>) => () => store.dispatch(injectAccessibilityIcon()),
};

export const handlerCreatorsForReadEvents: HandlerCreatorsForReadEvents = {
  [GET_PAGE_DATA]: getPageDataProtectedEventHandler,
  [GET_PALETTE_DATA]: getPaletteDataProtectedEventHandler,
};
